// Detects whether the app is running inside a native Capacitor shell (iOS/Android)
// rather than a normal web browser.
//
// Capacitor injects a global `window.Capacitor` at runtime in the native apps; on the
// web that global is absent. We read the global instead of importing @capacitor/core so
// the web build carries no Capacitor dependency. Once the native shell exists this
// returns true inside the app and false everywhere else.
//
// Used to hide in-app purchase / billing flows: the Apple App Store (Guideline 3.1.1)
// and Google Play prohibit steering users to external purchases for digital
// subscriptions, so billing stays web-only and the native apps show status only.
export function isNativePlatform() {
  try {
    const cap = typeof window !== "undefined" ? window.Capacitor : undefined;
    if (!cap) return false;
    if (typeof cap.isNativePlatform === "function") return !!cap.isNativePlatform();
    return cap.platform === "ios" || cap.platform === "android";
  } catch {
    return false;
  }
}

// Which native shell we're inside: "ios" | "android", or null on the web. Same
// read-the-global approach as isNativePlatform() above.
export function getNativePlatform() {
  try {
    const cap = typeof window !== "undefined" ? window.Capacitor : undefined;
    if (!cap) return null;
    const platform = typeof cap.getPlatform === "function" ? cap.getPlatform() : cap.platform;
    return platform === "ios" || platform === "android" ? platform : null;
  } catch {
    return null;
  }
}
